module.exports = __webpack_public_path__ + "static/media/Shape.1c8434ef.svg";